import { render, staticRenderFns } from "./apply-partner.vue?vue&type=template&id=bee35f36&scoped=true&"
import script from "./apply-partner.vue?vue&type=script&lang=js&"
export * from "./apply-partner.vue?vue&type=script&lang=js&"
import style0 from "./apply-partner.vue?vue&type=style&index=0&id=bee35f36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee35f36",
  null
  
)

export default component.exports